import React, { ReactNode } from 'react';

import {
  ApolloClient,
  ApolloLink,
  FetchResult,
  HttpLink,
  InMemoryCache,
  Observable,
  Operation,
} from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';

const httpLink = new HttpLink({
  uri: `${process.env.CONSUMER_HOST}/graphql`,
});

const customLink = new ApolloLink(
  (
    operation: Operation,
    forward: (op: Operation) => Observable<FetchResult>
  ) => {
    return forward(operation).map(response => {
      return response;
    });
  }
);

const client = new ApolloClient({
  link: ApolloLink.from([customLink, httpLink]),
  cache: new InMemoryCache(),
});

interface ApolloProviderWrapperProps {
  children: ReactNode;
}

export const ApolloProviderWrapper: React.FC<ApolloProviderWrapperProps> = ({
  children,
}) => <ApolloProvider client={client}>{children}</ApolloProvider>;
